import Api from './ApiService'

export default {
    get(keyword, pageNumber, sort) {
        return Api().get(`disciplina?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}`);
    },
    getOne(id) {
        return Api().get(`disciplina/${id}`);
    },
    create(data) {
        return Api().post(`disciplina`, data);
    },
    update(data) {
        return Api().put(`disciplina/${data.id}`, data);
    }
}